import React from 'react';
import ReactDOM from 'react-dom';

import {styled} from 'ps-gui';
import { formatHtml } from '../modules/utils';

const windowXMargin = 20;
const windowYMargin = 20;

export default class Tooltip extends React.Component {
	constructor() {
		super();
		this.ref = React.createRef();
	}

	offset() {
		return 8;
	}

	calcTop(up, anchor, height) {
		if (up) {
			return Math.floor(anchor.top - height - 8 - this.offset());
		} else {
			return Math.floor(anchor.bottom + 8 + this.offset());
		}
	}
	componentDidMount() {
		const anchor = this.props.anchor;
		const anchorCenterX = anchor.left + (anchor.right - anchor.left) / 2;
		const tooltip = this.ref.current;
		const arrow = tooltip.firstChild;
		const width = tooltip.offsetWidth;
		const height = tooltip.offsetHeight;
		const windowWidth = window.innerWidth - windowXMargin;
		const windowHeight = window.innerHeight - windowYMargin;
		let top;
		let left = anchorCenterX - width / 2;
		if (this.props.upFirst) {
			top = this.calcTop(true, anchor, height);
			if (top < windowYMargin) {
				top = this.calcTop(false, anchor, height);
				arrow.classList.add('top');
			} else {
				arrow.classList.add('bottom');
			}
		} else {
			top = this.calcTop(false, anchor, height);
			if (top > windowHeight - windowYMargin) {
				top = this.calcTop(true, anchor, height);
				arrow.classList.add('bottom');
			} else {
				arrow.classList.add('top');
			}
		}
		if ((left + width) > windowWidth) {
			left = windowWidth - width;
		} else if (left < windowXMargin) {
			left = windowXMargin;
		}
		arrow.style.left =  (anchorCenterX - left) + 'px';
		tooltip.style.top = top + 'px';
		tooltip.style.left = left + 'px';
	}

	renderContent() {
		return (
			<Wrapper className='ps-tooltip' ref={this.ref}>
				<Arrow/>
				<span dangerouslySetInnerHTML={{ __html: formatHtml(this.props.markup) }} />
			</Wrapper>
		);
	}

	render() {
		return ReactDOM.createPortal(this.renderContent(), document.getElementById('psGuiPopupContainer'));
	}
}

const Wrapper=styled.div`
	position: absolute;
	z-index: 1;
	border: 1px solid ${props => props.theme.textColor};
	border-radius: 15px;
	max-width: min(80vw, 800px);
	width: max-content;
	padding: 15px;
	background: white;
	text-align: justify;
	white-space: pre-wrap;
`;

const Arrow = styled.div`
	position: absolute;
	left: 50%;
	width: 16px;
	height: 16px;
	border: 1px solid ${props => props.theme.textColor};
	border-right: none;
	border-bottom: none;
	background: white;

	&.top {
		top: -9px;
		transform: rotate(45deg);
	}

	&.bottom {
		transform: rotate(225deg);
		bottom: -9px;
	}
`;
